import { useState } from "react";
import { H3, Label } from "../Text";
import { toast } from "react-toastify";
import Circle from "../Animation/Circle";
import { Button } from "../Buttons";
import { Request } from "../../hooks/Request";
import TableComplete from "../Tables/TableComplete";
import { requestAuth } from "../services/RequestService";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import CreatableSelect from "react-select/creatable";
import { validateArray } from "../../utils/validate";
import dayjs from "dayjs";
import { GenerateReceptionPDF } from "../../containers/ManegeProcedure/GenerateReceptionPDF";

const listFieldNames = [
  "a1NúmeroDeDeclaración", //DIM
  "numeroDeFactura", //numero de factura
];

const InputSubDataPaymentsReceiptAdd = ({ field }) => {
  const { openDialog, dialogClose } = useDialog();
  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
  });
  const { data: dataValues, loading: loadingDataValues } = Request({
    urlApi: `/Procedure/${field.id}/dataValues?${listFieldNames
      .map((field) => `fieldnames=${field}`)
      .join("&")}`,
  });

  const {
    data: document,
    loading: loadDocument,
    call: callDocument,
  } = Request({
    urlApi: field.urlApi,
  });

  function handleForm(item) {
    openDialog(
      <>
        {loadDocument && (
          <div className="min-h-[360px]">
            <FormAddDocument
              data={document}
              item={item}
              reload={call}
              field={field}
              onClose={dialogClose}
              callDocument={callDocument}
            />
          </div>
        )}
      </>
    );
  }

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar este item?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/dataSet/procedure/subData/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }

  function handleGenerateReceptionPDF(item) {
    openDialog(
      <GenerateReceptionPDF
        data={dataValues}
        item={item}
        onClose={dialogClose}
      />
    );
  }

  return (
    <div className="bg-gray-300/40 p-2 rounded-md">
      <Label htmlFor={field.name} className={`${field.className} my-0`}>
        {field.labelCustom ? field.labelCustom : field.label}
      </Label>
      <div className="bg-gray-100 rounded-lg p-3 pt-2">
        {loadDocument && (
          <FormAddDocument
            data={document}
            reload={call}
            field={field}
            onClose={() => {}}
            callDocument={callDocument}
          />
        )}
      </div>
      <br />
      {!loading ? (
        <Circle />
      ) : (
        <div className="w-full">
          <TableComplete
            header={[
              {
                name: "label",
                label: "Campo",
              },
              {
                name: "description",
                label: "Monto",
              },
              // {
              //   name: "description2",
              //   label: "Enlace",
              //   type: "custom",
              //   builder: (value) => {
              //     return (
              //       <div>
              //         <a
              //           className="text-blue-500 underline"
              //           href={value}
              //           target="_blank"
              //           rel="noopener noreferrer"
              //         >
              //           Ver archivo
              //         </a>
              //       </div>
              //     );
              //   },
              // },
              {
                name: "creationDate",
                label: "Fecha",
                type: "custom",
                builder: (value) => {
                  return <div>{dayjs(value).format("DD/MM/YYYY")}</div>;
                },
              },
              // {
              //   name: "observation",
              //   label: "Diferencia",
              // },
              {
                name: "add",
                type: "action",
                label: "Opciones",
                sticky: true,
                actions: [
                  {
                    label: "Generar PDF",
                    icon: "fas fa-file-pdf",
                    action: handleGenerateReceptionPDF,
                    color: "text-[#1d4ed8]",
                  },
                  {
                    label: "Editar",
                    icon: "fas  fa-edit",
                    action: handleForm,
                    color: "text-[#1d4ed8]",
                  },
                  {
                    label: "Añadir",
                    icon: "fas fa-trash",
                    action: handleDelete,
                    color: "text-red-500",
                  },
                ],
              },
            ]}
            data={data}
          />
        </div>
      )}
    </div>
  );
};

const FormAddDocument = (props) => {
  const { data, item = null, reload, field, onClose, callDocument } = props;
  const { openDialog, dialogClose } = useDialog();
  const [values, setValues] = useState({
    Label: item?.label ? item.label : validateArray(data) ? data[0].name : "",
    NumberValue: item?.numberValue ? item.numberValue : 0,
    Description: item?.description ? item.description : "",
    Description2: item?.description2 ? item.description2 : "",
    isNew: false,
  });

  async function handleSubmit() {
    if (values.isNew) {
      await handleCreateOption(values);
    }
    await requestAuth(
      item ? "put" : "post",
      item
        ? `/dataSet/procedure/subData/${item.id}`
        : `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
      item
        ? {
            ...values,
            // observation:
            //   parseFloat(values.Description2 ?? 0) -
            //   parseFloat(values.Description ?? 0),
          }
        : {
            ...values,
            // Description2: values.Description,
            // observation: 0,
          }
    )
      .then(() => {
        reload();
        onClose();
        setValues({
          ...values,
          NumberValue: 0,
          Description: "",
          Description2: "",
        });
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  async function uploadFile() {
    let formData = new FormData();
    formData.append("Name", values.Label);
    formData.append("File", values.Description2);
    formData.append("originalName", values.Description2.name ?? "");
    formData.append("Status", "verified");
    formData.append("ProcedureId", field.id);
    await requestAuth("post", "/files", formData)
      .then((res) => {
        handleSubmit({ ...values, Description2: res.data.url });
      })
      .catch(() => {
        toast.error("Se produjo un error al subir el archivo");
      });
  }

  async function handleCreateOption(value) {
    await requestAuth("post", "/Dropdown/Option", {
      Name: value.Label,
      DropdownListLabel: field.urlInitial,
    }).then(() => {
      callDocument();
    });
  }

  function handleChangeInp(e) {
    const { name, value } = e.target;
    setValues((a) => ({
      ...a,
      [name]: value,
    }));
  }
  function handleChange(e) {
    setValues((a) => ({
      ...a,
      Label: e.value,
      isNew: e.__isNew__ || false,
    }));
  }

  return (
    <form className="flex flex-col">
      <Label className={`mt-2`}>Concepto</Label>
      <div className="flex flex-col gap-2">
        <div className="w-full">
          {validateArray(data) ? (
            <CreatableSelect
              isSearchable={true}
              onChange={handleChange}
              styles={{
                placeholder: (base) => ({
                  ...base,
                  color: "black",
                }),
              }}
              defaultInputValue={item ? item.label : ""}
              placeholder={"Seleccionar..."}
              isOptionSelected={false}
              // isLoading={field.urlApi ? !loading : false}
              options={data.map((option) => ({
                value: option.name,
                label: option.name,
              }))}
            />
          ) : null}
        </div>
        {/* <div>
          <Label className={`my-0 mt-4`}>
            {item ? "Comprobante" : "Comprobante"}
          </Label>
          <div
            className="w-full shadow-md md:shadow-lg
                rounded-[7px] placeholder-black placeholder:text-[15px]
                placeholder:opacity-50 placeholder:font-normal
                px-[17px] sm:py-[15px] font-light
                text-[15px] bg-white/50 md:bg-white/75"
          >
            <input
              autoComplete="current-password"
              className="w-full text-sm text-grey-500
                  file:mr-5 file:py-2 file:px-6
                  file:rounded-full file:border-0
                  file:text-sm file:font-medium
                  file:bg-[#1d4ed8] file:text-white
                  hover:file:cursor-pointer hover:file:bg-[#1d4fd8ce]"
              type="file"
              onChange={(fileData) => {
                setValues((a) => ({
                  ...a,
                  Description2: fileData.target.files[0],
                }));
              }}
            />
          </div>
        </div> */}
        <div className="flex gap-2 items-center">
          <div className="w-full">
            <Label className={`my-0 mt-4`}>
              {item ? "Monto proforma" : "Monto"}
            </Label>
            <input
              value={values.Description}
              onChange={handleChangeInp}
              className="w-full p-2 rounded-md shadow-md md:shadow-lg"
              type="number"
              name="Description"
            />
          </div>

          <div className="pt-4 flex justify-end">
            <Button
              // onClick={uploadFile}
              onClick={handleSubmit}
              className={`px-3 py-2 ${item ? "mt-2 py-3" : "py-0"}`}
            >
              Guardar
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default InputSubDataPaymentsReceiptAdd;
